import React, { useState } from 'react';
import { RadioGroup, FormControlLabel, Radio, Box, Stack, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function SingleClientQuestionnaires({ Get, Vend }) {
  const navigate = useNavigate();
  const [selectedClient, setSelectedClient] = useState(null);
  const [showRadioGroup, setShowRadioGroup] = useState(true);
  const [startprq, setstartprq] = useState([]);
  const [getpqid, setpqid] = useState();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleClientChange = (event) => {
    setSelectedClient(event.target.value);
  };

  const handleContinueClick = () => {
    setIsLoading(true)
    // setShowRadioGroup(false);
    // navigate(
    //   "/StartPrequalification?clientSelection="+selectedClient+"&Vendor="+Vend+"&ismulti=false")
    // axios
    // .post(
    // "Prequalification/StartQuestionnaire?clientId="+selectedClient+"&vendorId="+Vend+"&isMultiClient=false"
    // )
    // .then((res) => {
    //   if (res?.data) {
    //       setstartprq(res?.data?.data?.templates);
    //       setpqid(res?.data?.data?.prequalificationId);

    //       if(res?.data?.data?.templates){
    //         console.log(getpqid,startprq);


    // }else{
    //     toast.error(res?.data.responseMessage, {
    //       position: "top-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "light",
    //     });
    //   }
    //   } else {
    //     setError(res.data.responseMessage);
    //   }
    // })
    // .catch((err) => {
    //   console.log(err);
    // }).finally(() => {
    //   setIsLoading(false); 
    // });

    axios
      .post("Prequalification/StartQuestionnaire?clientId=" + selectedClient + "&vendorId=" + Vend + "&isMultiClient=false")
      .then((res) => {
        if (res?.data) {
          setstartprq(res?.data?.data?.templates);
          setpqid(res?.data?.data?.prequalificationId);

          // if(res?.data?.data?.templates)
          const serializedData = JSON.stringify(res?.data?.data?.templates);

          navigate(
            "/TemplatesList?startprq=" + serializedData + "&pqid=" + res?.data?.data?.prequalificationId + "&CurrentTempID=" + res?.data?.data?.currentTemplateId)
          // } else {
          //   toast.error(res?.data.responseMessage, {
          //     position: "top-right",
          //     autoClose: 5000,
          //     hideProgressBar: false,
          //     closeOnClick: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     progress: undefined,
          //     theme: "light",
          //   });
          // }
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });

  };

  const handleBackClick = () => {
    setShowRadioGroup(true);
  };

  const handleStartPrequalificationClick = () => {
    // Handle the "Start Prequalification" click here
    // You can add your desired logic for this action
  };
  const handleCancleclick = () => {
    // Redirect to "/ClientSelect" when the button is clicked

    navigate(
      "/DashBoard")
  };
  return (
    <>
      {/* <Box style={{ backgroundColor: "#fff", padding: "20px", paddingBottom: "30px" }}>
      {showRadioGroup && (
        <RadioGroup name="client" value={selectedClient} onChange={handleClientChange}>
          <div>
            {Get?.filter((client) => client.isERI === false).map((client, index) => (
              <div key={index}>
                <Stack direction="row" spacing={2}>
                  <Stack spacing={0}>
                    <FormControlLabel
                      value={client.organizationID}
                      control={<Radio />}
                      label={<b style={{ fontSize: "16px" }}>{client.name}</b>}
                    />
                    <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                      {client.address1}, {client.city}, {client.state}, {client.country}
                    </span>
                    <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                      {client.phoneNumber}
                    </span>
                  </Stack>
                  <div style={{ marginLeft: "auto" }}>
                    <Box
                      bgcolor="#f2f2f2"
                      color="#999"
                      p={3}
                      borderRadius={4}
                      textAlign="right"
                      position="relative"
                      ml={2}
                      sx={{ width: "120px", height: "80px" }}
                    >
                      <span>No Logo</span>
                    </Box>
                  </div>
                </Stack>
                <br />
              </div>
            ))}
          </div>
        </RadioGroup>
      )}

      {showRadioGroup && (
        <div style={{ marginBottom: "20px" }}>
          <Stack direction="row" spacing={2} style={{ float: "right" }}>
            <Button variant="outlined" sx={{ padding: "15px" }} onClick={handleCancleclick}>Cancel</Button>
            <Button variant="contained" onClick={handleContinueClick}>Continue --{">"}</Button>
          </Stack>
        </div>
      )}

      {!showRadioGroup && (
        <div>
          <p>new component</p>
          <Stack direction="row" spacing={2} style={{ float: "right" }}>
            <Button variant="outlined" onClick={handleBackClick} sx={{ padding: "15px" }}>Back</Button>
            <Button variant="contained" onClick={handleStartPrequalificationClick}>Start Prequalification</Button>
          </Stack>
        </div>
      )}
    </Box> */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}

      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box style={{ backgroundColor: "#fff", padding: "20px", paddingBottom: "30px" }}>
        {/* {showRadioGroup && ( */}
        <RadioGroup name="client" value={selectedClient} onChange={handleClientChange}>
          <div>
            {Get?.filter((client) => client.isERI === false).map((client, index) => (
              <div key={index}>
                <Stack direction="row" spacing={2}>
                  <Stack spacing={0}>
                    <FormControlLabel
                      value={client.organizationID}
                      control={<Radio />}
                      label={<b style={{ fontSize: "16px" }}>{client.name}</b>}
                    />
                    <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                      {client.address1}, {client.city}, {client.state}, {client.country}
                    </span>
                    <span style={{ color: "#3E4A62", fontSize: "16px" }}>
                      {client.phoneNumber}
                    </span>
                  </Stack>
                  <div style={{ marginLeft: "auto" }}>
                    <img style={{ width: "100px", height: "100px", objectFit: "contain" }} src={"data:image/png;base64," + client?.clientLogoPath} />

                  </div>
                </Stack>
                <br />
              </div>
            ))}
          </div>
        </RadioGroup>
        {/* )} */}


        <div style={{ marginBottom: "20px" }}>
          <Stack direction="row" spacing={2} style={{ float: "right" }}>
            <Button variant="outlined" sx={{ padding: "15px" }} onClick={handleCancleclick}>Cancel</Button>
            <Button variant="contained" onClick={handleContinueClick} disabled={selectedClient == null}>Continue --{">"}</Button>
          </Stack>
        </div>



      </Box>
    </>
  );
}
